import { addClass, removeClass } from '@utils/domUtils';

export default class VisibilityToggler {
  init() {
    [...document.querySelectorAll(`[data-show]`)].forEach(element => {
      element.addEventListener('click', this.showElement.bind(this));
    });

    [...document.querySelectorAll(`[data-hide]`)].forEach(element => {
      element.addEventListener('click', this.hideElement.bind(this));
    });
  }

  showElement(event) {
    event.preventDefault();

    const target = event.currentTarget.getAttribute('data-show');
    const element = document.querySelector(target);

    if (element) {
      removeClass(element, 'hide');
      addClass(element, 'show');
    }
  }

  hideElement(event) {
    event.preventDefault();

    const target = event.currentTarget.getAttribute('data-hide');
    [...document.querySelectorAll(target)].forEach(element => {
      addClass(element, 'hide');
      removeClass(element, 'show');
    });
  }
}
